import { Badge } from '@/components/ui/badge';

const phases = [
  {
    n: 1,
    title: 'Sense',
    subtitle: 'Connect. See. Report.',
    desc: 'Plug in your POS, ticketing, and CRM. See everything in one dashboard. Auto-generate GM reports after every show.',
    active: true,
  },
  {
    n: 2,
    title: 'Predict',
    subtitle: 'Forecast. Staff. Project.',
    desc: 'Demand forecasting, staffing recommendations, and revenue projections, powered by your own historical data.',
    active: false,
  },
  {
    n: 3,
    title: 'Act',
    subtitle: 'Market. Alert. Convert.',
    desc: 'Marketing automation, VIP alerts, one-click campaigns. Turn insights into action without leaving the platform.',
    active: false,
  },
  {
    n: 4,
    title: 'Learn',
    subtitle: 'Compound. Optimize. Grow.',
    desc: 'AI recommendations that get smarter with every show. Every night makes the next one more profitable.',
    active: false,
  },
] as const;

const LaunchVisionSection = () => (
  <section id="roadmap" className="py-12 sm:py-20 px-4 sm:px-6">
    <div className="max-w-3xl mx-auto">
      <div className="text-center mb-14">
        <Badge variant="outline" className="mb-4">
          The Vision
        </Badge>
        <h2 className="text-3xl sm:text-4xl font-display font-bold">
          Built in Phases.
          <br className="hidden sm:block" />{' '}
          <span className="gradient-text">Guided by Operators.</span>
        </h2>
      </div>

      <div className="relative">
        <div className="absolute left-[22px] top-0 bottom-0 w-px bg-border" />

        <div className="space-y-0">
          {phases.map((phase) => (
            <div key={phase.n} className="relative flex gap-5 pb-10 last:pb-0">
              <div className="relative z-10 flex flex-col items-center">
                <div
                  className={`w-9 h-9 sm:w-11 sm:h-11 rounded-full flex items-center justify-center text-xs sm:text-sm font-bold border-2 ${
                    phase.active
                      ? 'bg-primary text-primary-foreground border-primary shadow-[0_0_12px_hsl(var(--primary)/0.4)]'
                      : 'bg-muted text-muted-foreground border-border'
                  }`}
                >
                  {phase.n}
                </div>
              </div>

              <div className="flex-1 pb-2">
                <div className="flex items-center gap-3 mb-1.5">
                  <h3
                    className={`text-lg font-display font-bold ${phase.active ? 'text-foreground' : 'text-muted-foreground'}`}
                  >
                    {phase.title}
                  </h3>
                  {phase.active && (
                    <span className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full bg-primary/10 border border-primary/20 text-[#c43d10] text-[11px] font-bold uppercase tracking-[0.1em]">
                      <span className="relative flex h-2 w-2">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75" />
                        <span className="relative inline-flex rounded-full h-2 w-2 bg-primary" />
                      </span>
                      You Are Here
                    </span>
                  )}
                </div>
                <p
                  className={`text-xs font-semibold uppercase tracking-[0.12em] mb-1.5 ${phase.active ? 'text-[#c43d10]' : 'text-muted-foreground'}`}
                >
                  {phase.subtitle}
                </p>
                <p className="text-sm text-muted-foreground leading-relaxed">{phase.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default LaunchVisionSection;
